export const GPT_RATE_LIMITING_ERROR = "Showing generic content as we were unable to create a personalized one";
export const SCHEDULED_FOLLOWUPS_AT = "To be sent on business days, with a gap of four days since your last email.";
